import Footer from 'components/Footer/Footer.jsx';
import AdminNavbar from 'components/Navbars/AdminNavbar.jsx';
import Sidebar from 'components/Sidebar/Sidebar.jsx';
import { OrdenExpressGetPathRoutes, OrdenExpressGetRoutes, FrameWorkMessageAceptCancel, OrdenExpressValidateSecurityForAnswer } from 'orden_express/frameWork/frameWork.js';
import FixedPlugin from 'orden_express/layouts/FixedPlugin';
import { requestMenuPermissions } from 'orden_express/login/loginEpic';
import PerfectScrollbar from 'perfect-scrollbar';
import React from 'react';
import { connect } from 'react-redux';
import { Switch } from 'react-router-dom';
import { routesAdmin } from 'routes.js';

var ps;

class Admin extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            backgroundColor: 'black',
            activeColor: 'warning',
            sidebarMini: false,
            profile: '/admin',
            alertSidebar: '',
        };
        this.props.requestMenuPermissions(OrdenExpressGetPathRoutes(routesAdmin, this.state.profile));
    }

    componentDidMount = () => {
        window.history.pushState(null, document.title, window.location.href);
        window.addEventListener('popstate', function (event) {
            event.preventDefault();
            window.history.pushState(null, document.title, window.location.href);
        });
        if (navigator.platform.indexOf('Win') > -1) {
            document.documentElement.className += ' perfect-scrollbar-on';
            document.documentElement.classList.remove('perfect-scrollbar-off');
            ps = new PerfectScrollbar(this.refs.mainPanel);
        }
    }

    componentWillUnmount = () => {
        if (navigator.platform.indexOf('Win') > -1) {
            ps.destroy();
            document.documentElement.className += ' perfect-scrollbar-off';
            document.documentElement.classList.remove('perfect-scrollbar-on');
        }
    }
    componentDidUpdate = (e) => {
        if (e.history.action === 'PUSH') {
            document.documentElement.scrollTop = 0;
            document.scrollingElement.scrollTop = 0;
            this.refs.mainPanel.scrollTop = 0;
        }
    }

    handleActiveClick = color => {
        this.setState({ activeColor: color });
    };

    handleBgClick = color => {
        this.setState({ backgroundColor: color });
    };

    handleMiniClick = () => {
        if (document.body.classList.contains('sidebar-mini')) {
            this.setState({ sidebarMini: false });
        } else {
            this.setState({ sidebarMini: true });
        }
        document.body.classList.toggle('sidebar-mini');
    };

    cancelGetOut = () => {
        //
    }

    answerGoOut = () => {
        document.documentElement.classList.toggle('nav-open', false);
        FrameWorkMessageAceptCancel(this, "Salir del sistema", "¿Desea salir del sistema? \n Recuerde grabar su solicitud antes de salir.", this.acceptGetOut, this.cancelGetOut, '', '', 'alertSidebar')
    }

    acceptGetOut = () => {
        OrdenExpressValidateSecurityForAnswer({ 'exitOfSystem': true });
    }
 
    render() {
        return (
            <div className='wrapper wrapper-full-page'
                ref='fullPages'>
                {this.state.alertSidebar}

                <Sidebar
                    key='Sidebar'
                    {...this.props}
                    routes={routesAdmin}
                    bgColor={this.state.backgroundColor}
                    activeColor={this.state.activeColor}
                    callbackGetOut={this.answerGoOut}
                    handleMiniClick={this.handleMiniClick}
                />

                <div className='main-panel' ref='mainPanel'>
                    <Switch>
                        {OrdenExpressGetRoutes(routesAdmin, this.state.profile)}
                    </Switch>
                    <AdminNavbar
                        {...this.props}
                        handleMiniClick={this.handleMiniClick}
                        routes={routesAdmin}
                        callbackGetOut={this.answerGoOut} />
                    <Footer fluid />
                </div>

                <FixedPlugin
                    bgColor={this.state.backgroundColor}
                    activeColor={this.state.activeColor}
                    handleActiveClick={this.handleActiveClick}
                    handleBgClick={this.handleBgClick}
                />
            </div>
        );
    }
}
const mapStateToProps = state => {
    return {
        loginReducerState: state.loginReducerState
    };
};

const mapDispatchToProps = dispatch => {
    return {
        requestMenuPermissions: (dataMenuPermissions) => dispatch(requestMenuPermissions(dataMenuPermissions)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Admin);